(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root = document) {
    const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
    if (previewTheme && /^\d+$/.test(previewTheme)) {
      root.querySelectorAll('a[href]').forEach(link => {
        const destination = new URL(link.href, location.href);
        if (destination.origin !== location.origin && ['https://iidelivered.com', 'https://wholesale.iidelivered.com'].includes(destination.origin)) {
          destination.searchParams.set('preview_theme_id', previewTheme);
          link.href = destination.href;
        }
      });
    }
    root.querySelectorAll('[data-iid-header]').forEach(header => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = 'true';
      const toggle = header.querySelector('[data-iid-menu-toggle]');
      const menu = header.querySelector('#iid-mobile-nav');
      const setMenu = open => {
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? toggle.dataset.menuCloseLabel : toggle.dataset.menuOpenLabel);
        menu.hidden = !open;
      };
      toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setMenu(false);
          toggle.focus();
        }
      });
      header.querySelectorAll('.nav a, .mobile-nav a').forEach(link => {
        if (new URL(link.href).origin === location.origin && new URL(link.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) link.setAttribute('aria-current', 'page');
        link.addEventListener('click', () => setMenu(false));
      });
    });
    root.querySelectorAll('[data-iid-carousel]').forEach(carousel => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const track = carousel.querySelector('[data-iid-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-iid-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-iid-dot]'));
      const count = carousel.querySelector('[data-iid-current]');
      let current = 0;
      let frame = null;
      const select = index => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        dots.forEach((dot, i) => i === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        slides.forEach((slide, i) => {
          slide.inert = i !== current;
          slide.setAttribute('aria-hidden', String(i !== current));
        });
        count.textContent = String(current + 1).padStart(2, '0');
      };
      const go = index => {
        const next = (index + slides.length) % slides.length;
        select(next);
        track.scrollTo({ left: next * track.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      carousel.querySelector('[data-iid-prev]').addEventListener('click', () => go(current - 1));
      carousel.querySelector('[data-iid-next]').addEventListener('click', () => go(current + 1));
      track.addEventListener('scroll', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => select(Math.round(track.scrollLeft / track.clientWidth)));
      }, { passive: true });
      carousel.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        go(current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      select(0);
      new ResizeObserver(() => track.scrollTo({ left: current * track.clientWidth, behavior: 'instant' })).observe(track);
    });
    const wholesaleFeedback = root.querySelector('[data-iid-wholesale-feedback]');
    if (wholesaleFeedback) wholesaleFeedback.focus();
    const productInput = root.querySelector('#iid-wholesale-products');
    if (productInput && !productInput.value) productInput.value = new URLSearchParams(location.search).get('product') || '';
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

